import React from 'react'
import './ProjectDropIndicator.scss'

export interface ProjectDropIndicatorProps {
  /** Die Fuge zwischen zwei Zeilen, in px ab der Oberkante der Projekt-Liste. */
  top: number
  /** Die Tiefe, in der das Projekt landet (0 = oben) — dort beginnt die Linie, auf Höhe des Icons. */
  depth: number
  /** Kein Platz: Der Ast ragte über Ebene 4. Die Linie wird grau, Loslassen ändert nichts. */
  blocked?: boolean
}

/**
 * **Die Ablage-Linie beim Ziehen eines Projekts** (#185) — eine Klammer wie der
 * Abstands-Indikator der Pinnwand (`MeasureLines`), im Ton des Lebensbereichs. Wo sie
 * beginnt, zeigt die Tiefe. Absolut in der Fuge, nimmt keinen Platz ein; die Rechnung
 * dahinter steht in `lib/projectTree` (`projectDropProjection`).
 *
 * @example
 * <div className="projects-tree"> … <ProjectDropIndicator top={96} depth={1} /></div>
 */
export const ProjectDropIndicator: React.FC<ProjectDropIndicatorProps> = ({ top, depth, blocked = false }) => (
  <div
    className={`project-drop-indicator project-drop-indicator--depth-${Math.max(0, Math.min(3, depth))}${blocked ? ' project-drop-indicator--blocked' : ''}`}
    // Die Fuge kommt aus der Messung der Zeilen — ein Wert, den kein Klassenname tragen kann.
    style={{ top }}
    aria-hidden="true"
    data-testid="project-drop-indicator"
  />
)
